export default __webpack_public_path__ + "static/media/android-os.e23432c9.svg";